import { render, staticRenderFns } from "./AppLangSwitcher.vue?vue&type=template&id=53f5696e&scoped=true&"
import script from "./AppLangSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppLangSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AppLangSwitcher.vue?vue&type=style&index=0&id=53f5696e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5696e",
  null
  
)

export default component.exports